<template>
  <b-card>
    <loading
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="fullPage"
    ></loading>
    <b-row>
      <b-col md="4">
        <b-form-group>
          <b-form-select
            v-model="filter2"
            :options="select.filterOptions"
            required
            class="input-new"
            @change="resetFilter"
          />
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-input-group v-if="filter2 === '1'">
          <b-form-input
            v-model="form.name"
            type="text"
            id="filterInput"
            placeholder="Type to Search"
            class="input-new"
            @click="resetIndex"
          ></b-form-input>
        </b-input-group>
        <b-input-group v-if="filter2 === '2'">
          <b-form-input
            v-model="form.email"
            type="text"
            id="filterInput"
            placeholder="Type to Search"
            class="input-new"
            @click="resetIndex"
          ></b-form-input>
        </b-input-group>
      </b-col>
      <b-col md="4">
        <b-form-group>
          <b-button
            variant="primary"
            class="input-new"
            v-if="filter2 !== null"
            @click="onClickSearch"
            >SEARCH</b-button
          >
          &nbsp;&nbsp;&nbsp;
          <b-button
            variant="warning"
            class="input-new"
            v-if="filter2 !== null"
            @click="clearFilter"
            >CLEAR</b-button
          >
        </b-form-group>
      </b-col>
    </b-row>

    <!--TABLE -->
    <b-table
      show-empty
      head-variant="dark"
      striped
      hover
      bordered
      :items="items"
      :fields="fields"
      id="my-table"
    >
      <template v-slot:cell(index)="data">
        {{ pagination.startIndex + data.index }}
      </template>
      <template v-slot:cell(role)="data">
        <span v-if="data.value == 1">Admin</span>
        <span v-if="data.value == 2">Stokis</span>
        <span v-if="data.value == 3">Home Dealer</span>
        <span v-if="data.value == 4">Agent</span>
        <span v-if="data.value == 5">Distributor</span>
      </template>
      <template v-slot:cell(action)="data">
        <span>
          <b-button
            variant="primary"
            size="sm"
            @click="onClickSubDealerView(data.item.id)"
            >{{ data.value.id }}VIEW</b-button
          >
        </span>
      </template>
    </b-table>
    <b-pagination
      v-model="pagination.current"
      :total-rows="pagination.total"
      :per-page="pagination.perPage"
      @change="onChangePage"
      v-if="!isLoading"
    ></b-pagination>

    <br />

    <div v-if="items.length >= 1">
      <b-row>
        <b-col md="4" style="padding-top:27px;">
          <b-form-group>
            <b-button
              variant="primary"
              class="input-new"
              @click="onDownloadUser"
              >Download User</b-button
            >
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-form-group class="col-md-4">
          <label :for="`input-size`"
            >Year <span class="danger-new"> *</span></label
          >
          <b-form-select
            v-model="form.year"
            :options="select.year"
            class="input-new"
            required
            @change="filterMonth"
          ></b-form-select>
          <p v-if="error.year">
            <span class="danger-new">{{ this.error.year }}</span>
          </p>
        </b-form-group>
        <b-form-group class="col-md-4">
          <label :for="`input-size`"
            >Month <span class="danger-new"> *</span></label
          >
          <b-form-select
            v-model="form.month"
            :options="select.month"
            class="input-new"
            required
            @change="selectMonth"
          ></b-form-select>
          <p v-if="error.month">
            <span class="danger-new">{{ this.error.month }}</span>
          </p>
        </b-form-group>
      </b-row>
      <b-row>
        <b-col md="4">
          <label :for="`input-size`"
            >Type <span class="danger-new"> *</span></label
          >
          <b-form-select
            v-model="form.excel_type"
            :options="select.excel_type"
            class="input-new"
            required
            @change="changeType"
          ></b-form-select>
          <p v-if="error.type">
            <span class="danger-new">{{ this.error.type }}</span>
          </p>
        </b-col>
        <b-col
          md="4"
          v-if="
            form.excel_type == '3' ||
              form.excel_type == '4' ||
              form.excel_type == '5'
          "
        >
          <label :for="`input-size`"
            >Sub Type <span class="danger-new"> *</span></label
          >
          <b-form-select
            v-model="form.sub_excel_type"
            :options="select.sub_excel_type"
            class="input-new"
            required
          ></b-form-select>
        </b-col>
        <b-col>
          <b-button variant="primary" size="sm" @click="downloadExcel">
            GENERATE REPORT
          </b-button>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import SuccessGenerateReport from "@/pages/Notifications/SuccessGenerateReport";
import Failed from "@/pages/Notifications/Failed";
export default {
  data() {
    return {
      items: [],
      form: {
        name: null,
        email: null,
        year: "",
        month: "",
        excel_type: "",
        sub_excel_type: "",
        page: 1
      },
      isLoading: false,
      fullPage: true,
      indexsearch: 1,
      filter2: null,
      select: {
        excel_type: [{ value: "", text: "Please Select" }],
        sub_excel_type: [],
        filterOptions: [
          { text: "Please Select", value: null },
          { text: "Name", value: "1" },
          { text: "Email", value: "2" }
        ],
        year: [],
        month: []
      },
      pagination: {
        total: 0,
        current: 1,
        perPage: 10,
        startIndex: 0
      },

      error: {
        year: "",
        month: "",
        type: ""
      }
    };
  },
  components: {
    Loading
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  mounted() {},
  created() {
    this.getReporType();
    this.getReportCategory();
    this.getYearUpline();
    this.getMonth();

    if (this.tab !== "1") {
      this.getSubDealer();
      return;
    }

    if (this.filter) {
      this.filter2 = this.filter !== "null" ? this.filter : null;
      this.pagination.current = this.page !== "null" ? this.page : null;
      this.indexsearch = this.page !== "null" ? this.page : null;
      this.form.name = this.name !== "null" ? this.name : null;
      this.form.email = this.email !== "null" ? this.email : null;

      if (this.filter !== "null") {
        this.onClickSearch();
      } else {
        this.pagination.current = this.page !== "null" ? this.page : null;
        this.getSubDealer();
      }
    } else {
      this.getSubDealer();
    }
  },
  props: {
    fields: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      required: false
    },
    filter: {
      type: String,
      default: null
    },
    page: {
      type: String
    },
    name: {
      type: String
    },
    email: {
      type: String
    },
    tab: {
      type: String
    }
  },

  methods: {
    // onClickView() {
    //   this.$router.push({ path: `stockout_view_user` });
    // },
    filterMonth() {
      this.form.month = "";
      this.form.excel_type = "";
      this.form.sub_excel_type = "";
      this.getMonth();
    },
    getMonth() {
      this.isLoading = true;
      this.select.month = [{ value: "", text: "Please Select" }];

      this.$store.dispatch("getReftable", "month&all=1").then(res => {
        this.isLoading = false;
        res.data.data.month.forEach(element => {
          this.select.month.push({
            value: element.ref_code,
            text: element.desc
          });
        });
      });
    },
    getYearUpline() {
      this.form.year = "";
      this.select.year = [];
      this.select.year.push({ value: "", text: "Please Select" });
      let data = {
        upline: this.$store.getters.getUser_id
      };
      this.$store.dispatch("getYearUpline", data).then(res => {
        res.data.data.forEach(item => {
          this.select.year.push({
            value: item,
            text: item
          });
        });
      });
    },
    changeType() {
      if (
        this.form.excel_type == "3" ||
        this.form.excel_type == "4" ||
        this.form.excel_type == "5"
      ) {
        this.form.sub_excel_type = 1;
      } else {
        this.form.sub_excel_type = "";
      }
    },

    selectMonth() {
      this.form.excel_type = "";

      const find = this.select.excel_type.find(
        element => parseInt(element.value) === parseInt(8)
      );

      if (parseInt(this.form.month) === 0) {
        find.disabled = true;
      } else {
        find.disabled = false;
      }
    },
    resetFilter() {
      this.form.email = null;
      this.form.name = null;
    },
    clearFilter() {
      this.filter2 = null;
      this.form.email = null;
      this.form.name = null;
      this.getSubDealer();
    },
    resetIndex() {
      this.indexsearch = 1;
    },
    onClickSubDealerView(id) {
      this.$router.push({
        path: `subdealer_user?id=${id}&cat=1&type=${this.type}&page=${this.pagination.current}&filter=${this.filter2}&date=null&outlet_name=null&email=${this.form.email}&name=${this.form.name}`
      });
    },
    getReporType() {
      this.isLoading = true;
      this.$store.dispatch("getReftable", "reportype").then(res => {
        this.isLoading = false;
        let data = res.data.data.reportype.filter(
          element => element.ref_code !== 7
        );
        data.forEach(element => {
          this.select.excel_type.push({
            value: element.ref_code,
            text: element.desc
          });
        });
        this.select.excel_type.push({
          value: "8",
          text: "All Category",
          disabled: false
        });
      });
    },
    getReportCategory() {
      this.isLoading = true;
      this.$store.dispatch("getReftable", "reportcategory").then(res => {
        this.isLoading = false;
        res.data.data.reportcategory.forEach(element => {
          this.select.sub_excel_type.push({
            value: element.ref_code,
            text: element.desc
          });
        });
      });
    },
    getSubDealer() {
      this.isLoading = true;
      this.$store
        .dispatch("getSubDealer", this.pagination.current)
        .then(res => {
          if (res.data.response.code === 100) {
            this.isLoading = false;
            this.items = [];
            res.data.data.data.forEach(element => {
              this.items.push({
                name: element.name,
                role: element.access_lvl,
                id: element.user_id
              });
            });
          }
          this.pagination.total = res.data.data.total;
          this.pagination.current = res.data.data.current_page;
          this.pagination.perPage = res.data.data.per_page;
          this.pagination.startIndex = res.data.data.from;
          this.indexsearch = res.data.data.current_page;
        });
    },
    onClickSearch() {
      this.isLoading = true;
      this.form.page = this.indexsearch;
      this.form.year = this.year;

      if (this.filter2 === null) {
        this.getSubDealer();
      } else {
        this.$store.dispatch("searchSubDealer", this.form).then(res => {
          this.isLoading = false;
          this.items = [];
          if (res.data.response.code === 100) {
            this.isLoading = false;
            res.data.data.data.forEach(element => {
              this.items.push({
                name: element.name,
                role: element.access_lvl,
                id: element.user_id
              });
            });
          }
          this.pagination.total = res.data.data.total;
          this.pagination.current = res.data.data.current_page;
          this.pagination.perPage = res.data.data.per_page;
          this.pagination.startIndex = res.data.data.from;
          this.indexsearch = res.data.data.current_page;
        });
      }
    },
    downloadExcel() {
      this.checkForm();
      this.isLoading = true;
      let data = {
        month: this.form.month,
        year: this.form.year,
        report_type: this.form.excel_type,
        report_category: this.form.sub_excel_type
      };
      this.$store.dispatch("downloadExcelAdmin", data).then(res => {
        this.isLoading = false;
        if (res.data.response.code === 100) {
          this.$notify({
            component: SuccessGenerateReport,
            icon: "ti-check",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success"
          });
          window.open(
            `${process.env.VUE_APP_BASE_URL}/${res.data.data.path + ".xlsx"}`,
            "_blank"
          );
        } else {
          this.$notify({
            component: Failed,
            icon: "ti-close",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger"
          });
        }
      });
    },
    onChangePage(index) {
      this.pagination.current = index;
      if (this.filter2 === null) {
        this.getSubDealer();
      } else {
        this.indexsearch =
          this.pagination.current !== this.indexsearch
            ? this.pagination.current
            : this.indexsearch++;
        this.onClickSearch();
      }
    },

    checkForm(e) {
      this.error.year = "";
      this.error.month = "";
      this.error.type = "";

      if (this.form.year && this.form.excel_type) return true;

      if (!this.form.year) this.error.year = "Outlet Category required.";

      if (!this.form.excel_type) this.error.type = "Type is required.";

      e.preventDefault();
    },

    onDownloadUser() {
      let data = {
        user_id: "",
        state: ""
      };
      this.isLoading = true;
      this.$store.dispatch("downloadUser", data).then(res => {
        this.isLoading = false;
        if (res.data.response.code === 100) {
          this.$notify({
            component: SuccessGenerateReport,
            icon: "ti-check",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success"
          });

          window.open(
            `${process.env.VUE_APP_BASE_URL}/${res.data.data.path + ".xlsx"}`,
            "_blank"
          );
        } else {
          this.$notify({
            component: Failed,
            icon: "ti-close",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger"
          });
        }
      });
    }
  }
};
</script>
<style lang="css" scoped></style>
